<template>
  <Prompt
    activatorSize="small"
    activatorIconSize="small"
    activatorIcon="fa-copy"
    inputText="Nouveau nom pour la copie"
    @submit="v => copyRecipe(v)"
  ></Prompt>
</template>

<script>
import { api } from "@/api";
export default {
  name: "RecipeCopy",
  props: {
    id: {
      required: true
    }
  },
  methods: {
    async copyRecipe(name) {
      try {
        this.$store.dispatch("startLoadingOverlay");
        const data = {
          name: name,
          id: this.id
        };
        await api.copyRecipe(data);
        this.$router.push({ name: "RecipeIndex" });
      } finally {
        this.$store.dispatch("endLoadingOverlay");
      }
    }
  }
};
</script>

<style></style>
